import script from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=1bbd05c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbd05c2"]])

export default __exports__